import { HttpClient, HttpEvent, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AppleApplication, Configuration } from '@rocksoft/mdm-sdk-v2';
import { Observable } from 'rxjs';

@Injectable()
export class UploadService {
  private readonly httpClient = inject(HttpClient);
  private readonly configuration = inject(Configuration);

  public addApplicationForm(
    fileName: Blob,
    apiVersion?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<AppleApplication>> {
    let queryParameters = new HttpParams();
    if (apiVersion !== undefined && apiVersion !== null) {
      queryParameters = queryParameters.set('api-version', apiVersion);
    }

    const formParams = new FormData();
    formParams.append('fileName', fileName);

    let headers = new HttpHeaders();
    // authentication (oauth2) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }

    if (!this.configuration.basePath) {
      throw new Error('Base path is not set');
    }

    return this.httpClient.request('post', `${this.configuration.basePath}/applications/apple/upload`, {
      body: formParams,
      params: queryParameters,
      withCredentials: this.configuration.withCredentials,
      headers,
      observe,
      reportProgress,
    });
  }
}
